"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Networks = void 0;
var Networks;
(function (Networks) {
    Networks["TWITTER"] = "twitter";
    Networks["INSTAGRAM"] = "instagram";
    Networks["FACEBOOK"] = "facebook";
    Networks["YOUTUBE"] = "youtube";
    Networks["PINTEREST"] = "pinterest";
    Networks["TIKTOK"] = "tiktok";
    Networks["INSTA_STORIES"] = "insta_stories";
    Networks["FACEBOOK_STORIES"] = "facebook_stories";
    Networks["BLOG"] = "blog";
    Networks["SNAPCHAT"] = "snapchat";
    Networks["INSTAGRAM_BUSINESS"] = "instagram_business";
    Networks["INSTAGRAM_CREATOR"] = "instagram_creator";
    Networks["TWITCH"] = "twitch";
    Networks["DOUYIN"] = "douyin";
    // Notice! if you add here more keys, need to make sure Frontend is still compiling successfully.
})(Networks = exports.Networks || (exports.Networks = {}));
//# sourceMappingURL=networks.enum.js.map